import { useLocation } from 'react-router-dom';

import { useEffectiveBranding, useIsEffectiveBrandingReady } from '@/hooks/use-effective-branding';
import { usePlatformBranding } from '@/hooks/use-platform-branding';
import { isPlatformAdminRoute } from '@/lib/branding/is-platform-admin-route';

/** Merchant CRM branding vs fixed TagadaPay chrome on admin routes. */
export const useAppBranding = () => {
  const { pathname } = useLocation();
  const effective = useEffectiveBranding();
  const platform = usePlatformBranding();
  return isPlatformAdminRoute(pathname) ? platform : effective;
};

/**
 * True once `useAppBranding()` reflects the authoritative brand for this
 * route — always true on platform-admin routes (synchronous platform brand);
 * on merchant routes it defers to `useIsEffectiveBrandingReady`.
 */
export const useIsAppBrandingReady = (): boolean => {
  const { pathname } = useLocation();
  const effectiveReady = useIsEffectiveBrandingReady();
  return isPlatformAdminRoute(pathname) ? true : effectiveReady;
};
